import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type LanguagePageWithId = {
  idLanguagePage: number;
};

// Типы для WebSocket сообщений компонента languagePages
type LanguagePageTranslationsMessage = WebSocketMessageWithFields<'language-page-translations' | 'language-page-item-list' | 'language-page-item-list-translations', {
  languagePage: unknown;
}>;
type LanguagePagesListMessage = WebSocketMessageWithFields<'language-page-list', {
  languagePages: unknown[];
}>;
type LanguagePageCreateMessage = WebSocketMessageWithFields<'language-page-create' | 'language-page-create-success', LanguagePageWithId & {
  name: string;
}>;
type LanguagePageDeleteMessage = WebSocketMessageWithFields<'language-page-delete' | 'language-page-delete-success', LanguagePageWithId>;

// Объединенный тип для всех сообщений
type LanguagePagesWebSocketMessage = 
  | LanguagePageTranslationsMessage 
  | LanguagePagesListMessage 
  | LanguagePageCreateMessage 
  | LanguagePageDeleteMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataLanguagePages',
},
  __name: 'languagePages',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID языковой страницы
const handleWebSocketMessage = (data: LanguagePagesWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'language-page-translations':
    case 'language-page-item-list':
    case 'language-page-item-list-translations':
      store.dispatch('languagePage/wsSetLanguagePage', data.languagePage);
      break;

    case 'language-page-list':
      store.dispatch('languagePages/wsSetLanguagePages', { languagePages: data.languagePages });
      break;

    case 'language-page-create':
    case 'language-page-create-success':
      store.dispatch('languagePages/wsLanguagePageCreate', {
        idLanguagePage: data.idLanguagePage,
        name: data.name,
      });
      break;

    case 'language-page-delete':
    case 'language-page-delete-success':
      store.dispatch('languagePages/wsLanguagePageDelete', { idLanguagePage: data.idLanguagePage });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})